<template>
  <div class="codes">
    <p>Enter the provided Vehicle Testing Station number and activation code into TestWatcher to complete the activation process.</p>

    <div v-for="(activation, i) in $store.state.activationResults" :key="i">
      <b-alert show variant="light" class="activation-alert">
        <h4 class="alert-heading">{{ activation.machine_name }}</h4>
        <hr />
        <div class="row text-larger">
          <div class="col">
            VTS Number:
            <span class="activation-code ml-2 is-primary text-bold">{{ activation.vts_number }}</span>
          </div>
          <div class="col">
            Activation Code:
            <span class="activation-code ml-2 is-primary text-bold">{{ activation.code }}</span>
          </div>
        </div>
      </b-alert>
    </div>

    <p
      v-if="$store.state.activationResults && $store.state.activationResults.length > 0"
    >Note: These activation codes will expire in {{moment($store.state.activationResults[0].expires_at).fromNow()}}</p>
  </div>
</template>

<style lang="scss" scoped>
.activation-alert {
  border: 1px solid #093;
  border-left: 6px solid #093;
}
</style>

<script>
import moment from "moment";

export default {
  name: "codes",
  data() {
    return {
      showConfirmModal: false
    };
  },
  methods: {
    moment(str) {
      return moment(str);
    }
  }
};
</script>